"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var DropdownList_component_exports = {};
__export(DropdownList_component_exports, {
  DropdownList: () => DropdownList
});
module.exports = __toCommonJS(DropdownList_component_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_react = __toESM(require("react"));
var import_react2 = require("@floating-ui/react");
var import_Select = require("../Select.styled");
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var DropdownList = function DropdownList2(_ref) {
  var isOpen = _ref.isOpen, refs = _ref.refs, children = _ref.children, context = _ref.context, elementsRef = _ref.elementsRef, floatingMargin = _ref.floatingMargin, getFloatingProps = _ref.getFloatingProps, labelsRef = _ref.labelsRef, modifiedFloatingStyles = _ref.modifiedFloatingStyles, onKeyDown = _ref.onKeyDown;
  return /* @__PURE__ */ import_react.default.createElement(import_react2.FloatingFocusManager, {
    context,
    modal: false
  }, /* @__PURE__ */ import_react.default.createElement("div", {
    role: "navigation",
    onKeyDown,
    tabIndex: -1,
    style: {
      visibility: !isOpen ? "hidden" : "visible"
    }
  }, /* @__PURE__ */ import_react.default.createElement(_StyledDiv, _extends({
    "aria-expanded": "true",
    ref: refs.setFloating,
    style: _objectSpread(_objectSpread({}, modifiedFloatingStyles), {}, {
      overflowY: "auto"
    })
  }, getFloatingProps(), {
    "data-testid": "select-list-testid",
    $_css: [{
      "display": "flex",
      "minWidth": "11rem",
      "maxWidth": "20rem",
      "flexDirection": "column",
      "borderStyle": "none",
      "--tw-shadow": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
      "--tw-shadow-colored": "0 25px 50px -12px var(--tw-shadow-color)",
      "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
    }, floatingMargin, import_Select.customScroll]
  }), /* @__PURE__ */ import_react.default.createElement(import_react2.FloatingList, {
    elementsRef,
    labelsRef
  }, children))));
};
var _StyledDiv = (0, import_styled_components.default)("div").withConfig({
  displayName: "DropdownListcomponent___StyledDiv",
  componentId: "sc-11haalg-0"
})(["", ""], function(p) {
  return p.$_css;
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DropdownList
});
//# sourceMappingURL=DropdownList.component.js.map